export function shouldShowBackToTop(hasLoadedMoreArticles: boolean, scrollY: number, threshold = 480): boolean {
  return hasLoadedMoreArticles && scrollY > threshold;
}
